import { makeVar } from '@apollo/client';
import { IMarketplace } from 'types/cache/Marketplace';

export const marketplaceVar = makeVar<IMarketplace>({
  travelPlans: [],
});
